import type { ChartData, Chart as ChartType } from 'chart.js';
import { computed, type ComputedRef } from 'vue';
import gettext from '@/i18n/gettext';

const { $gettext } = gettext;

export interface TimeMetric {
  lastTimestamp: number;
  avgTimeBetween: number;
  totalTime: number;
}

export interface TimeMetricsMap {
  [key: string]: TimeMetric;
}

export interface CountMetricsRecord {
  day: string;
  agg_counts: {
    [key: string]: number;
  };
}

export interface TimeMetricsRecord {
  day: string;
  agg_times: {
    [key: string]: number;
  };
}

export interface ChartUpdateConfig {
  chart: ChartType | undefined;
  datasets: ChartData<'bar'>['datasets'];
  colorMap: Record<string, string>;
  labelMap: Record<string, string>;
}

export interface MetricsDataset {
  label: string;
  data: number[];
  backgroundColor: string;
  borderColor?: string;
  borderWidth?: number;
  stack?: string;
}

export const timeColorMap: Record<string, string> = {
  planned_downtime: '#facc15',
  unplanned_downtime: '#f87171',
  idle: '#c8c8c8',
  starved: '#60a5fa',
  blocked: '#a78bfa',
  producing: '#4ade80',
  no_data: '#eceef0', // Excluded from OEE: Spans with no telemetry events
};

export const countColorMap: Record<string, string> = {
  good_count: '#4ade80',
  bad_count: '#f87171',
  fault: '#facc15',
  failure: '#a78bfa',
};

export const timeLabelDisplayMap: ComputedRef<Record<string, string>> =
  computed(() => {
    return {
      planned_downtime: $gettext('Planned Downtime'),
      unplanned_downtime: $gettext('Unplanned Downtime'),
      idle: $gettext('Idle'),
      starved: $gettext('Starved'),
      blocked: $gettext('Blocked'),
      producing: $gettext('Producing'),
      no_data: $gettext('No Data'),
    };
  });

export const countLabelDisplayMap: ComputedRef<Record<string, string>> =
  computed(() => {
    return {
      good_count: $gettext('Good Count'),
      bad_count: $gettext('Bad Count'),
      fault: $gettext('Fault'),
      failure: $gettext('Failure'),
    };
  });
